import styled from 'styled-components';
import {theme} from '@styles/theme';

export const ModalWrapper = styled.div`
  width: 432px;
`;

export const ModalContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 24px;
  padding: 24px;
  justify-content: center;
  border-top: 1px solid ${theme.colors.basic06};
`;

export const SelectedAdminBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  background-color: ${theme.colors.basic07};
  border-radius: ${theme.roundedMedium};
`;

export const SelectedAdminWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px 20px 8px 0;
  svg {
    cursor: pointer;
  }
`;

export const SelectedAdminInfoWrapper = styled.div`
  display: flex;
  gap: 8px;
`;
